import React from "react";
import { Stack, Text, Button, Alert } from "@mantine/core";
import { FaInfoCircle, FaEye } from "react-icons/fa";

interface NoAssignedPoolsBannerProps {
    onViewAllPools?: () => void;
}

const NoAssignedPoolsBanner: React.FC<NoAssignedPoolsBannerProps> = ({ onViewAllPools }) => {
    return (
        <Stack align="center" justify="center" h="100%" p="xl" gap="md">
            <Alert
                icon={<FaInfoCircle size={20} />}
                title="No Assigned Pools"
                color="blue"
                variant="light"
                w="100%"
            >
                <Stack gap="sm">
                    <Text size="sm">
                        You currently have no license pools assigned to you. Contact your administrator to be assigned pools.
                    </Text>
                    {onViewAllPools && (
                        <Button
                            variant="light"
                            color="blue"
                            size="sm"
                            leftSection={<FaEye size={14} />}
                            onClick={onViewAllPools}
                        >
                            View All Pools
                        </Button>
                    )}
                </Stack>
            </Alert>
        </Stack>
    );
};

export default NoAssignedPoolsBanner;
